import type { MessageTemplate, TemplateType, PreselectRole } from '../../types/tracker.types';

export interface TemplateCreatorModalProps {
  /** Whether the modal is open */
  isOpen: boolean;
  /** Callback when modal is closed */
  onClose: () => void;
  /** Callback when template is saved successfully */
  onSave: (template: MessageTemplate) => void;
  /** Optional template to edit (if null, creates new) */
  editTemplate?: MessageTemplate | null;
}

export interface TemplateFormData {
  name: string;
  type: TemplateType;
  content: string;
  subject: string;
  preselect_role: PreselectRole;
  fallback_greeting: string;
}

export type VariableCategory = 'contacts' | 'dossier';

export interface TemplateVariable {
  id: string;
  label: string;
  placeholder: string;
  description: string;
  category: VariableCategory;
}

export interface VariableCategoryInfo {
  id: VariableCategory;
  label: string;
}

export const VARIABLE_CATEGORIES: VariableCategoryInfo[] = [
  { id: 'contacts', label: 'Contacts' },
  { id: 'dossier', label: 'Dossier' },
];

export const TEMPLATE_VARIABLES: TemplateVariable[] = [
  // Contact variables
  {
    id: 'destinataire',
    label: 'Destinataire',
    placeholder: '{destinataire}',
    description: 'Nom du destinataire sélectionné',
    category: 'contacts',
  },
  {
    id: 'demandeur',
    label: 'Demandeur',
    placeholder: '{demandeur}',
    description: 'Nom du demandeur',
    category: 'contacts',
  },
  {
    id: 'proprietaire',
    label: 'Propriétaire',
    placeholder: '{proprietaire}',
    description: 'Nom du propriétaire',
    category: 'contacts',
  },
  {
    id: 'client',
    label: 'Client',
    placeholder: '{client}',
    description: 'Nom du client',
    category: 'contacts',
  },
  {
    id: 'expert',
    label: 'Expert',
    placeholder: '{expert}',
    description: "Nom de l'expert assigné",
    category: 'contacts',
  },
  {
    id: 'tel_expert',
    label: 'Tél Expert',
    placeholder: '{tel_expert}',
    description: "Numéro de téléphone de l'expert",
    category: 'contacts',
  },
  // Dossier variables
  {
    id: 'reference',
    label: 'Référence',
    placeholder: '{reference}',
    description: 'Numéro de dossier',
    category: 'dossier',
  },
  {
    id: 'adresse',
    label: 'Adresse',
    placeholder: '{adresse}',
    description: 'Adresse du bien',
    category: 'dossier',
  },
  {
    id: 'date_rv',
    label: 'Date RDV',
    placeholder: '{date_rv}',
    description: 'Date du rendez-vous',
    category: 'dossier',
  },
  {
    id: 'heure_rv',
    label: 'Heure RDV',
    placeholder: '{heure_rv}',
    description: 'Heure du rendez-vous',
    category: 'dossier',
  },
  {
    id: 'montant',
    label: 'Montant',
    placeholder: '{montant}',
    description: 'Montant total TVAC',
    category: 'dossier',
  },
];

export const ROLE_OPTIONS: { value: PreselectRole; label: string }[] = [
  { value: null, label: 'Aucun (sélection manuelle)' },
  { value: 'demandeur', label: 'Demandeur' },
  { value: 'proprietaire', label: 'Propriétaire' },
  { value: 'client', label: 'Client' },
  { value: 'expert', label: 'Expert' },
];
